// refactor sass to stylejs (no theme usage)
import UiDialog from 'ui-components/ui-dialog/UiDialog';
import { styled } from '@mui/material/styles';
import { css } from '@emotion/react';

export const StyledVersionListDialog = styled(UiDialog)(
  () => css`
    &.version-list {
      .MuiDialogContent-root {
        padding: 20px !important;
      }
      .version-name {
        font-weight: bold;
        font-size: 0.875rem;
        line-height: 24px;
        margin-bottom: 6px;
      }
      .version-list-item {
        margin: 0;
        padding: 6px 18px;
        font-size: 0.875rem;
        line-height: 20px;
        .version-description {
          &::marker {
            color: #009688;
          }
          margin-block-start: 0 !important;
          .version-link {
            color: #008bf8;
            margin-right: 8px;
          }
        }
      }
    }
  `
);
